/** Таймкод относится только к явно открытой публикации, а не к соседним при листании. */
export function evidenceStart(state: unknown, postId: number): number {
  if (!state || typeof state !== 'object') return 0
  const target = state as { evidencePostId?: unknown; evidenceSeek?: unknown }
  return target.evidencePostId === postId && typeof target.evidenceSeek === 'number' && Number.isFinite(target.evidenceSeek) && target.evidenceSeek >= 0 ? target.evidenceSeek : 0
}
